var exports = {
  "Y3": "anchor__jg5b7s",
  "Qs": "content__kAoUse",
  "h_": "description__uqVVlb",
  "n_": "queryList__yPlWgz",
  "kB": "queryItem__6AOwBv",
  "TE": "queryLabel__TKfqCQ",
  "zZ": "queryRow__8n8-WM",
  "wP": "queryText__0apQy-",
  "Sh": "token__Iy8iy7",
  "vA": "tokenValue__8EYNvp",
  "ie": "tokenValueDynamic__nbV03S",
  "pY": "tokenKeyword__jBw3k1",
};

module.exports = exports;
